export const SEARCH_WATCHLIST = "SEARCH_WATCHLIST";
export const SEARCH_WATCHLIST_ERROR = "SEARCH_WATCHLIST_ERROR";
export const SEARCH_WATCHLIST_HIDE_ERROR = "SEARCH_WATCHLIST_HIDE_ERROR";
export const SEARCH_WATCHLIST_START_LOADER = "SEARCH_WATCHLIST_START_LOADER";
export const SEARCH_WATCHLIST_STOP_LOADER = "SEARCH_WATCHLIST_STOP_LOADER";
